import {parseISO} from "date-fns";

import {formatPL} from "@pg-mono/string-utils";

// "2026-02-01" -> "luty 2026" (nominative, for labels)
export const formatRcnPeriodMonth = (periodStart: string): string => formatPL(parseISO(periodStart), "LLLL yyyy");

// "2026-02-01" -> "lutego 2026" (genitive, for "dane z lutego 2026")
export const formatRcnPeriodMonthGenitive = (periodStart: string): string => formatPL(parseISO(periodStart), "MMMM yyyy");

// "2022-01-01" -> "2022 r." (a yearly point's period_start, for the address history chart)
export const formatRcnPeriodYear = (periodStart: string): string => `${periodStart.slice(0, 4)} r.`;

// "2026-01-01" -> "ze stycznia 2026", "2026-02-01" -> "z lutego 2026"
export const formatRcnPeriodWithPreposition = (periodStart: string): string => {
    const month = formatRcnPeriodMonthGenitive(periodStart);

    return `${month.startsWith("st") ? "ze" : "z"} ${month}`;
};
import {parseISO} from "date-fns";

import {formatPL} from "@pg-mono/string-utils";

// "2026-02-01" -> "luty 2026" (nominative, for labels)
export const formatRcnPeriodMonth = (periodStart: string): string => formatPL(parseISO(periodStart), "LLLL yyyy");

// "2026-02-01" -> "lutego 2026" (genitive, for "dane z lutego 2026")
export const formatRcnPeriodMonthGenitive = (periodStart: string): string => formatPL(parseISO(periodStart), "MMMM yyyy");

// "2022-01-01" -> "2022 r." (a yearly point's period_start, for the address history chart)
export const formatRcnPeriodYear = (periodStart: string): string => `${periodStart.slice(0, 4)} r.`;

// "2026-01-01" -> "ze stycznia 2026", "2026-02-01" -> "z lutego 2026"
export const formatRcnPeriodWithPreposition = (periodStart: string): string => {
    const month = formatRcnPeriodMonthGenitive(periodStart);

    return `${month.startsWith("st") ? "ze" : "z"} ${month}`;
};
